import { MEDIA_IMG_URL } from "../../services/lib/constants.js";
// import { useUser } from "../../store/redux/slices/userSlice.js";

// Shuffle array
export function shuffleArray(array) {
  return array.sort(() => Math.random() - 0.5);
}

// Score color
export function scoreColor(score) {
  let bgColor, color;
  switch (true) {
    case score >= 7:
      bgColor = "bg-green-900";
      color = "text-green-400";
      break;
    case score >= 4:
      bgColor = "bg-yellow-800";
      color = "text-yellow-200";
      break;
    case score > 0:
      bgColor = "bg-red-900";
      color = "text-red-200";
      break;
    default:
      bgColor = "bg-stone-700";
      color = "text-stone-100";
  }
  return { bgColor, color };
}

// Format date
export function formatDate(dateString) {
  if (!dateString) return "";
  return new Date(dateString).toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

// Format runtime
export function formatRuntime(runtime) {
  const hours = Math.floor(runtime / 60);
  const minutes = Math.floor(runtime % 60);
  if (hours === 0 && minutes === 0) return "Unknown";
  return `${hours}h ${minutes}m`;
}

// Shorten text
export function shortenText(text, limit) {
  const shortenedText =
    text.length > limit
      ? text.slice(0, 250).trim().split(" ").slice(0, -1).join(" ") + "..."
      : text;
  return shortenedText;
}

// Get media images
const NO_MOVIE_POSTER = "/noMoviePoster.png";
const NO_PERSON_PHOTO = "/noPersonPhoto.png";
const NO_SHOW_POSTER = "/noMoviePoster.png";
const NO_MOVIE_COVER = "/noMovieCover.png";

export function getMediaImages(media, type) {
  const posterPath =
    type === "person"
      ? media.profile_path
        ? `${MEDIA_IMG_URL}w500${media.profile_path}`
        : NO_PERSON_PHOTO
      : media.poster_path
      ? `${MEDIA_IMG_URL}w500${media.poster_path}`
      : media.image || media.thumbnail || NO_MOVIE_POSTER;

  const backgroundImage =
    type === "person"
      ? ""
      : media.backdrop_path
      ? `url(${MEDIA_IMG_URL}original${media.backdrop_path})`
      : media.image || media.thumbnail
      ? `url(${media.image || media.thumbnail})`
      : `url(${NO_MOVIE_COVER})`;

  return { posterPath, backgroundImage };
}

// Get search media data
export function getSearchMediaData(media) {
  const {
    title,
    name,
    media_type,
    poster_path,
    profile_path,
    release_date,
    first_air_date,
  } = media;

  let mediaTitle, mediaType, mediaImage;
  switch (media_type) {
    case "tv":
      mediaTitle = name;
      mediaType = "shows";
      mediaImage = getMediaImagesSearch(poster_path, NO_SHOW_POSTER);
      break;
    case "person":
      mediaTitle = name;
      mediaType = "person";
      mediaImage = getMediaImagesSearch(profile_path, NO_PERSON_PHOTO);
      break;
    default:
      mediaTitle = title;
      mediaType = "movies";
      mediaImage = getMediaImagesSearch(poster_path, NO_MOVIE_POSTER);
  }

  const date = release_date || first_air_date;
  const releaseDate = date ? new Date(date).getFullYear() : "";
  mediaTitle = `${mediaTitle} ${
    mediaType !== "person" ? `(${releaseDate})` : ""
  }`;

  return { mediaTitle, mediaType, mediaImage };
}

// Get media image search
export function getMediaImagesSearch(path, defaultImage) {
  return path ? `${MEDIA_IMG_URL}w500${path}` : defaultImage;
}
export function titleToKey(title) {
  // Rimuove accenti, trasforma in minuscolo, rimpiazza spazi e caratteri speciali
  return title
    .normalize('NFD')                           // separa lettere da accenti
    .replace(/[\u0300-\u036f]/g, '')            // rimuove accenti
    .replace(/[^a-zA-Z0-9 ]/g, '')              // elimina caratteri speciali
    .trim()                                     // toglie spazi inizio/fine
    .replace(/\s+/g, '-')                       // spazi -> trattini
    .toLowerCase();
}
// Get user list info
export const getUserListsInfo = ({ type, id }) => {
  // const {
  //   likedMovies,
  //   likedShows,
  //   likedPeople,
  //   watchlistMovies,
  //   watchlistShows,
  //   ratedMovies,
  //   ratedShows,
  // } = useUser();

  // let isLiked = false,
  //   isInWatchList = false,
  //   isRated = null;

  // switch (type) {
  //   case "movie":
  //   case "movies":
  //     isLiked = likedMovies.some((movie) => movie.id === id);
  //     isInWatchList = watchlistMovies.some((movie) => movie.id === id);
  //     isRated = ratedMovies.find((movie) => movie.id === id);
  //     break;
  //   case "tv":
  //     isLiked = likedShows.some((show) => show.id === id);
  //     isInWatchList = watchlistShows.some((show) => show.id === id);
  //     isRated = ratedShows.find((show) => show.id === id);
  //     break;
  //   case "person":
  //     isLiked = likedPeople.some((person) => person.id === id);
  //     break;
  // }

  // return { isLiked, isInWatchList, isRated };
};
